import { useEffect, useState } from 'react';

/**
 * This hook checks if the user is using a supported browser.
 * @returns {boolean} isSupportedBrowser - A boolean value indicating whether the user is using a supported browser
 */
const useBrowserWarning = () => {
  const [isSupportedBrowser, setIsSupportedBrowser] = useState(true);

  useEffect(() => {
    const userAgent = navigator?.userAgent;

    if (userAgent) {
      // Check if the browser is Chrome, Safari, Edge or Firefox
      const isChrome = userAgent.includes('Chrome') && !userAgent.includes('Edg');
      const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent) && !userAgent.includes('OPR') &&
        !userAgent.includes('OPT') && !userAgent.includes('Opera');
      const isEdge = userAgent.includes('Edg');
      const isFirefox = userAgent.includes('Firefox');

      setIsSupportedBrowser(isChrome || isSafari || isEdge || isFirefox);
    } else {
      setIsSupportedBrowser(false);
    }

  }, []);

  return isSupportedBrowser;
};

export default useBrowserWarning;
